import '../scss/style.scss';
import 'bootstrap/dist/js/bootstrap.min.js';
import slick from 'slick-carousel';

// detect entry into div
function closestEdge(x, y, w, h) {
  var topEdgeDist = distMetric(x, y, w / 2, 0);
  var bottomEdgeDist = distMetric(x, y, w / 2, h);
  var leftEdgeDist = distMetric(x, y, 0, h / 2);
  var rightEdgeDist = distMetric(x, y, w, h / 2);

  var min = Math.min(topEdgeDist, bottomEdgeDist, leftEdgeDist, rightEdgeDist);
  switch (min) {
    case leftEdgeDist:
      return "left";
    case rightEdgeDist:
      return "right";
    case topEdgeDist:
      return "top";
    case bottomEdgeDist:
      return "bottom";
  }
}

function distMetric(x, y, x2, y2) {
  var xDiff = x - x2;
  var yDiff = y - y2;
  return (xDiff * xDiff) + (yDiff * yDiff);
}

function setFlipInfo() {
  $(".flip-info").hover(function (e) {
    var el_pos = $(this).offset();
    var edge = closestEdge(e.pageX - el_pos.left, e.pageY - el_pos.top, $(this).width(), $(this).height());
    $(this).attr("class","in-"+edge);
  }, function (e) {
    var el_pos = $(this).offset();
    var edge = closestEdge(e.pageX - el_pos.left, e.pageY - el_pos.top, $(this).width(), $(this).height());
    $(this).attr("class", "out-" + edge);
  });
}

/*!
 * IE10 viewport hack for Surface/desktop Windows 8 bug
 * Copyright 2014-2017 The Bootstrap Authors
 * Copyright 2014-2017 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

// See the Getting Started docs for more information:
// https://getbootstrap.com/getting-started/#support-ie10-width
(function () {
  'use strict'
  if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
      document.createTextNode(
        '@-ms-viewport{width:auto!important}'
      )
    )
    document.head.appendChild(msViewportStyle)
  }

  //custom
  if ($(".grid").length) {
    var workTiles = imagesLoaded('.grid');
    workTiles.on('progress', function (instance, image) {
      var msnry = new Masonry('.grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
        columnWidth: '.grid-sizer'
      });
    });
  }
  if ($(".staff-info").length) {
    setFlipInfo();
    $(".page-id-960 .staff-info a").click(function(n){
      n.preventDefault(); n.stopPropagation();
    })
  }

  if ($(".service-slider").length)
    $(".service-slider").slick({
      infinite: true,
      slidesToScroll: 4,
      slidesToShow: 4,
      arrows: true,
      dots: false,
      prevArrow: "<button type='button' class='slick-prev'><i class='far fa-chevron-left' aria-hidden='true'></i></button>",
      nextArrow: "<button type='button' class='slick-next'><i class='far fa-chevron-right' aria-hidden='true'></i></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
}());





